import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall, formattedPrice} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Lottie from 'react-lottie';
import './Credits.css';
import visacard from "../../assets/images/visa.png";
import mastercard from "../../assets/images/mastercard.png";
import iyzico from "../../assets/images/iyzico.png";

class Credits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        cardHolderName: "",
        cardNumber: "",
        expiryDate: "",
        cvc: "",
        product_id:'',
        value:'',
        price:'',
      },
      selectedId:'',
      currentCredit:'',
      showCard: false,
      currentRefCode: null,
      products:[
        { id: 1, value: 100, price: 1100 },
        { id: 2, value: 250, price: 1915 },
        { id: 3, value: 500, price: 3250 },
        { id: 4, value: 1000, price: 4950 },
        { id: 5, value: 2500, price: 10680 },
        { id: 6, value: 5000, price: 16320 },
        { id: 7, value: 10000, price: 27000 },
        { id: 8, value: 25000, price: 43850 },
      ],
      isLoad:true,
      loading:false,
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getCurrentCredit();
  }
  getCurrentCredit = async () => {
    try {
      const response = await apiCall('business/ksoft/current-credit','get',null);
      this.setState({currentCredit:response},()=>{
        this.setState({isLoad:false})
      });
    }catch (e) {
      console.log(e);
      this.setState({isLoad:false});
    }
  }
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSelectedChange = (id) => {
    let product = this.state.products.find(product => product.id === id);
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        product_id: product.id,
        value: product.value,
        price: product.price,
      },
      selectedId:id,
      showCard: true
    }), () => {
      // Auto scroll to payment form
      setTimeout(() => {
        const paymentCard = document.querySelector('.payment-card');
        if (paymentCard) {
          const yOffset = -100;
          const y = paymentCard.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
        }
      }, 300);
    });
  };
  handleExpiryDateChange = (event) => {
    let input = event.target.value;
    input = input.replace(/\D/g, "");
    if (input.length > 2) {
      input = input.slice(0, 2) + '/' + input.slice(2);
    }
    if (input.length > 5) {
      input = input.slice(0, 5);
    }

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        expiryDate: input
      }
    }));
  };
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    const { formData } = this.state;
    try {
      const resposne = await apiCall('business/ksoft/credit-pay','post',formData);
      this.setState({loading: false});
      await this.getCurrentCredit();
      mainHelper.toastMessage(resposne.status,resposne.message)
    }catch (e) {
      console.log(e);
      this.setState({loading: false});
    }
  }
  upgrade = async (event) => {
    event.preventDefault();
    this.setState({loading: true});
    const formData  = {
      currentRef:this.state.currentRefCode,
      newRef:this.state.prodRefCode
    };
    try {
      const resposne = await apiCall('business/iyzico/upgrade-subscripstion','post',formData);
      this.setState({loading: false});
      mainHelper.toastMessage(resposne.status,resposne.message)
    }catch (e) {
      console.log(e);
      this.setState({loading: false});
    }
  }

  render() {
    const {products,loading} = this.state;
    
    const coinAnimation = {
      loop: true,
      autoplay: true,
      animationData: require('../../assets/assets/box.json'),
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return (
      <div
        className="credits-page-modern"
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="E-Fatura Kontör Yükle"
                Breadcrumb={[
                  {name: "Faturalar", navigate: ""},
                  {name: "Kontör", navigate: "settings/subscription/detail"},
                  {name: "Kontör Yükle", navigate: ""},
                ]}
            />
            <form id="paymentForm" onSubmit={this.handleSubmit}>
              {/* Modern Header Section with Current Credit */}
              <div className="modern-credit-header-section">
                <div className="header-content">
                  <div className="lottie-animation-wrapper">
                    <Lottie options={coinAnimation} height={100} width={100}/>
                  </div>
                  <h2 className="main-heading">
                    <span className="gradient-text">E-Fatura Kontör Paketi Seçin</span>
                  </h2>
                  <p className="sub-heading">
                    Faturalarınızı kesebilmek için kontör yükleyin
                  </p>
                  
                  {/* Current Credit Badge */}
                  <div className="current-credit-badge">
                    <div className="badge-icon">
                      <i className="fa fa-wallet"></i>
                    </div>
                    <div className="badge-content">
                      <span className="badge-label">Mevcut Kontör</span>
                      <span className="badge-value">{this.state.currentCredit} Adet</span>
                    </div>
                  </div>

                  <div className="credit-features">
                    <div className="feature-badge">
                      <i className="fa fa-file-invoice"></i>
                      <span>E-Fatura</span>
                    </div>
                    <div className="feature-badge">
                      <i className="fa fa-bolt"></i>
                      <span>Anında Kullanıma Hazır</span>
                    </div>
                    <div className="feature-badge">
                      <i className="fa fa-shield-alt"></i>
                      <span>Güvenli Ödeme</span>
                    </div>
                  </div>
                </div>
              </div>
              {/* Modern Credit Packages Grid */}
              <div className="row clearfix modern-credit-grid">
                {products.length > 0 ? (
                    products.map((product, index) => {
                      const isSelected = this.state.selectedId === product.id;
                      const isMostPreferred = product.id === 4; // 1000 adet
                      const cardColor = index < 2 ? "#e00a17" : (index < 5 ? "#1d75bd" : "#28a745");
                      
                      return (
                        <div className="col-lg-3 col-md-6 col-sm-12" key={product.id}>
                          <div className={`modern-credit-card ${isSelected ? 'selected-card' : ''} ${isMostPreferred ? 'most-preferred' : ''}`}>
                            {isMostPreferred && <div className="most-preferred-badge">En Çok Tercih Edilen</div>}
                            
                            <div className="card-body">
                              <div className="credit-icon-container" style={{background: `linear-gradient(135deg, ${cardColor}22 0%, ${cardColor}05 100%)`}}>
                                <i className="fa fa-coins" style={{color: cardColor, fontSize: '3rem'}}></i>
                              </div>
                              
                              <div className="credit-amount">
                                <h2 className="amount-value" style={{color: cardColor}}>{product.value}</h2>
                                <span className="amount-label">Adet Kontör</span>
                              </div>
                              
                              <div className="price-section">
                                <div className="unit-price">Birim Fiyat: {formattedPrice(product.price / product.value)}</div>
                                <div className="total-price">{formattedPrice(product.price)}</div>
                              </div>
                              
                              <button
                                  type="button"
                                  className={`modern-select-btn ${isSelected ? 'selected' : ''}`}
                                  style={{
                                    background: isSelected ? cardColor : 'transparent',
                                    borderColor: cardColor,
                                    color: isSelected ? 'white' : cardColor
                                  }}
                                  onClick={() => this.handleSelectedChange(product.id)}
                              >
                                {isSelected ? (
                                  <>
                                    <i className="fa fa-check-circle"></i> Seçildi
                                  </>
                                ) : (
                                  <>
                                    <i className="fa fa-shopping-cart"></i> Seç
                                  </>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                      <div className="col-12">
                        <div className="alert alert-warning text-center">Ürün Bulunmamaktadır.</div>
                      </div>
                  )}
                </div>
                {/* Modern Payment Form */}
                <div className="row clearfix justify-content-center">
                  <div className="col-lg-12">
                    <div className={`card payment-card ${this.state.showCard ? 'show' : ''}`}>
                      <div className="col-lg-12 d-flex justify-content-center">
                        <div className="col-lg-7 col-md-12">
                          <div className="modern-payment-form">
                            <div className="form-section">
                              <h5 className="section-title">
                                <i className="fa fa-credit-card"></i> Kart Bilgileri
                              </h5>
                              
                              <div className="modern-form-group">
                                <label className="modern-label">Kart Üzerindeki İsim</label>
                                <div className="modern-input-wrapper">
                                  <i className="fa fa-user input-icon"></i>
                                  <input
                                      className="modern-input"
                                      placeholder="AD SOYAD"
                                      type="text"
                                      name="cardHolderName"
                                      value={this.state.formData.cardHolderName}
                                      onChange={this.handleInputChange}
                                      required
                                  />
                                </div>
                              </div>

                              <div className="modern-form-group">
                                <label className="modern-label">Kart Numarası</label>
                                <div className="modern-input-wrapper">
                                  <i className="fa fa-credit-card input-icon"></i>
                                  <input
                                      className="modern-input"
                                      placeholder="1234 5678 9012 3456"
                                      type="text"
                                      name="cardNumber"
                                      value={this.state.formData.cardNumber}
                                      onChange={this.handleInputChange}
                                      maxLength="16"
                                      required
                                  />
                                  <div className="card-brands">
                                    <img src={visacard} alt="Visa" />
                                    <img src={mastercard} alt="Mastercard" />
                                  </div>
                                </div>
                              </div>

                              <div className="form-row-modern">
                                <div className="modern-form-group flex-2">
                                  <label className="modern-label">Son Kullanma Tarihi</label>
                                  <div className="modern-input-wrapper">
                                    <i className="fa fa-calendar input-icon"></i>
                                    <input
                                        className="modern-input"
                                        placeholder="MM/YY"
                                        type="text"
                                        name="expiryDate"
                                        value={this.state.formData.expiryDate}
                                        onChange={this.handleExpiryDateChange}
                                        maxLength="5"
                                        required
                                    />
                                  </div>
                                </div>

                                <div className="modern-form-group flex-1">
                                  <label className="modern-label">
                                    CVV <i className="fa fa-question-circle" title="Kartınızın arkasındaki 3 haneli kod"></i>
                                  </label>
                                  <div className="modern-input-wrapper">
                                    <i className="fa fa-lock input-icon"></i>
                                    <input 
                                        className="modern-input"
                                        placeholder="123"
                                        type="text"
                                        name="cvc"
                                        value={this.state.formData.cvc}
                                        onChange={this.handleInputChange}
                                        maxLength="3"
                                        required
                                    />
                                  </div>
                                </div>
                              </div>

                              {loading ? (
                                <button className="modern-submit-btn" disabled={true}>
                                  <ReactLoading type="spin" color="#ffffff" width={'20px'} height={'20px'} />
                                  İşleniyor...
                                </button>
                              ) : (
                                <button className="modern-submit-btn" type="submit">
                                  <i className="fa fa-lock"></i>
                                  Güvenli Ödeme Yap
                                </button>
                              )}

                              <div className="payment-security">
                                <div className="security-item">
                                  <i className="fa fa-shield-alt"></i>
                                  <span>256-bit SSL Şifreleme</span>
                                </div>
                                <div className="security-item">
                                  <img src={iyzico} alt="iyzico" style={{height: '20px'}} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default connect(mapStateToProps, {})(Credits);
